var utils = {}
window.utils = {}

utils.callback = (callback) => {
    if (typeof callback == 'function') {
        callback()
    }
}

utils.setBackgroundBody = (routerName) => {
    let arrayNoBackgroundBody = ['login', 'demonstrativoIndividual', 'demonstrativoEmpresa', 'termoAssinaturaMedico']
    if (arrayNoBackgroundBody.indexOf(routerName) > -1) {
        $('body').removeClass('backGreySure')
    } else {
        $('body').addClass('backGreySure')
    }
}

export default utils
